import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from "@app/core/authentication/authentication.service";
import { ConstantService } from '../../shared/services/constant.service';

@Injectable()
export class ManufacturingAuthGuard  {
    constructor(
        private _authService: AuthenticationService,
        private _constantService: ConstantService,
        private _router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        if (this._constantService._isSupport || this._constantService._isHardware) {
            return true;
        } else if (this._constantService._isTypeAdmin && this._authService.isAuthenticated) {
            return true;
        } {
            return true;
        }
    }


    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        return this.canActivate(childRoute, state);
    }
}
